/**
 * @ngdoc config
 * @name routeProviderConfig
 * @description
 * Sets the routes for the Accounts, Login and Logout section:
 * - The default one (`/`).
 *
 * @param {Service} $routeProvider The interface for the Angular router.
 * @memberof account
 */
const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/accounts', {
    template: '<accounts></accounts>',
  })
  .when('/login', {
    template: '<login></login>',
  })
  .when('/logout', {
    params: {
      updated: null,
    },
    template: ({ updated }) => `<logout updated="${updated}"></logout>`,
  });
};

export default routeProviderConfig;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/configs/routeProvider.config.js